import { CalendarCheck } from 'lucide-react';
import { Badge } from '../../components/ui/badge';
import { formatSlotLine } from '../../lib/fitnessBot/booking';
import { appointmentProviderLabel, appointmentStaffLabel, slotGoneEvidenceLine } from '../../lib/appointments/appointmentView';
import type { Appointment } from '../../types/appointments';

/**
 * The booked tour on a conversation: when, which calendar it went into (badge), who with (initials only for an
 * Anytime Fitness booking), and for AF the slot-gone evidence line. Staff-facing.
 */
export function AppointmentLine({ appointment }: { appointment: Appointment }) {
  const evidence = slotGoneEvidenceLine(appointment);
  const staff = appointmentStaffLabel(appointment);
  return (
    <div className="mt-2 rounded-md border border-border px-3 py-2 text-sm" data-testid="appointment-line">
      <div className="flex flex-wrap items-center gap-2">
        <CalendarCheck className="h-4 w-4 text-muted-foreground" />
        <span className="font-medium">Tour booked {formatSlotLine(appointment.startsAt, appointment.timezone)}</span>
        {staff !== '' && <span className="text-muted-foreground">{staff}</span>}
        <Badge variant="neutral" data-testid="appointment-provider">
          {appointmentProviderLabel(appointment)}
        </Badge>
      </div>
      {evidence && (
        <p
          className={`mt-1 text-xs ${appointment.slotGoneConfirmed === false ? 'text-amber-700' : 'text-muted-foreground'}`}
          data-testid="appointment-evidence"
        >
          {evidence}
        </p>
      )}
    </div>
  );
}
